export const countries = [
    {
        "label": "Afghanistan",
        "value": "AF",
        "logo": "🇦🇫",
        "searchTerms": [
            "Afghan",
            "Islamic Republic of Afghanistan",
            "Afganistan",
            "Afghan Country",
            "AFG"
        ]
    },
    {
        "label": "Albania",
        "value": "AL",
        "logo": "🇦🇱",
        "searchTerms": [
            "Republic of Albania",
            "Shqipëri",
            "Shqiperia",
            "Albanian",
            "ALB"
        ]
    },
    {
        "label": "Algeria",
        "value": "DZ",
        "logo": "🇩🇿",
        "searchTerms": [
            "People's Democratic Republic of Algeria",
            "Al Jazair",
            "Algerie",
            "Algerian",
            "DZ",
            "DZA"
        ]
    },
    {
        "label": "Andorra",
        "value": "AD",
        "logo": "🇦🇩",
        "searchTerms": [
            "Andorra",
            "Principality of Andorra",
            "Principat d'Andorra",
            "Andorran",
            "AD"
        ]
    },
    {
        "label": "Angola",
        "value": "AO",
        "logo": "🇦🇴",
        "searchTerms": [
            "Angola",
            "Republic of Angola",
            "Angolan",
            "AO",
            "AGO"
        ]
    },
    {
        "label": "Anguilla",
        "value": "AI",
        "logo": "🇦🇮",
        "searchTerms": [
            "Anguilla",
            "AI",
            "AIA",
            "Anguillan",
            "British Anguilla",
            "Caribbean Anguilla"
        ]
    },
    {
        "label": "Antigua and Barbuda",
        "value": "AG",
        "logo": "🇦🇬",
        "searchTerms": [
            "Antigua",
            "Barbuda",
            "Antigua & Barbuda",
            "Antigua and Barbuda",
            "AG",
            "ATG",
            "Antiguan",
            "Barbudan",
            "Antigua Barbuda"
        ]
    },
    {
        "label": "Argentina",
        "value": "AR",
        "logo": "🇦🇷",
        "searchTerms": [
            "Argentina",
            "Argentine",
            "Argentinian",
            "Arg",
            "AR",
            "ARG",
            "Republic of Argentina",
            "La Argentina"
        ]
    },
    {
        "label": "Armenia",
        "value": "AM",
        "logo": "🇦🇲",
        "searchTerms": [
            "Armenia",
            "Armenian",
            "Hayastan",
            "AM",
            "ARM",
            "Republic of Armenia"
        ]
    },
    {
        "label": "Australia",
        "value": "AU",
        "logo": "🇦🇺",
        "searchTerms": [
            "Down Under",
            "Australia",
            "AU",
            "AUS",
            "Commonwealth of Australia",
            "Aussies",
            "Aust"
        ]
    },
    {
        "label": "Austria",
        "value": "AT",
        "logo": "🇦🇹",
        "searchTerms": [
            "Österreich",
            "Austria",
            "AT",
            "AUT",
            "Republic of Austria",
            "Oesterreich"
        ]
    },
    {
        "label": "Azerbaijan",
        "value": "AZ",
        "logo": "🇦🇿",
        "searchTerms": [
            "Azərbaycan",
            "Azerbaijan",
            "AZ",
            "AZE",
            "Republic of Azerbaijan"
        ]
    },
    {
        "label": "Bahamas",
        "value": "BS",
        "logo": "🇧🇸",
        "searchTerms": [
            "Bahamas Islands",
            "Caribbean Bahamas",
            "The Bahamas",
            "Bahamas",
            "BS",
            "BHS",
            "Commonwealth of The Bahamas",
            "Bahama"
        ]
    },
    {
        "label": "Bahrain",
        "value": "BH",
        "logo": "🇧🇭",
        "searchTerms": [
            "Bahrain Island",
            "Bahrain",
            "BH",
            "BHR",
            "Kingdom of Bahrain",
            "Al-Bahrain"
        ]
    },
    {
        "label": "Bangladesh",
        "value": "BD",
        "logo": "🇧🇩",
        "searchTerms": [
            "BDT",
            "Bangla",
            "Bangladesh",
            "BD",
            "BGD",
            "People's Republic of Bangladesh",
            "Bengal"
        ]
    },
    {
        "label": "Barbados",
        "value": "BB",
        "logo": "🇧🇧",
        "searchTerms": [
            "Bajan",
            "Barbados Island",
            "Caribbean Barbados",
            "Barbados",
            "BB",
            "BRB",
            "Island of Barbados"
        ]
    },
    {
        "label": "Belarus",
        "value": "BY",
        "logo": "🇧🇾",
        "searchTerms": [
            "Belarussian",
            "White Russia",
            "Belarus",
            "BY",
            "BLR",
            "Republic of Belarus",
            "Belorussia"
        ]
    },
    {
        "label": "Belgium",
        "value": "BE",
        "logo": "🇧🇪",
        "searchTerms": [
            "Belgique",
            "België",
            "Belgium",
            "BE",
            "BEL",
            "Kingdom of Belgium",
            "Brussel",
            "Flanders",
            "Wallonia"
        ]
    },
    {
        "label": "Belize",
        "value": "BZ",
        "logo": "🇧🇿",
        "searchTerms": [
            "Belize City",
            "British Honduras",
            "Belize",
            "BZ",
            "BLZ",
            "Caribbean Belize",
            "Belizean"
        ]
    },
    {
        "label": "Benin",
        "value": "BJ",
        "logo": "🇧🇯",
        "searchTerms": [
            "Beninese",
            "Dahomey",
            "Benin",
            "BJ",
            "BEN",
            "Republic of Benin",
            "Bénin"
        ]
    },
    {
        "label": "Bhutan",
        "value": "BT",
        "logo": "🇧🇹",
        "searchTerms": [
            "Druk",
            "Land of the Thunder Dragon",
            "Bhutan",
            "BT",
            "BTN",
            "Kingdom of Bhutan",
            "Druk Yul"
        ]
    },
    {
        "label": "Bolivia",
        "value": "BO",
        "logo": "🇧🇴",
        "searchTerms": [
            "Bolivian",
            "Plurinational State",
            "Bolivia",
            "BO",
            "BOL",
            "Plurinational State of Bolivia",
            "Estado Plurinacional de Bolivia",
            "Boliviano"
        ]
    },
    {
        "label": "Bosnia and Herzegovina",
        "value": "BA",
        "logo": "🇧🇦",
        "searchTerms": [
            "BiH",
            "Bosnia",
            "Herzegovina",
            "Bosnia & Herzegovina",
            "BA",
            "BIH",
            "Bosnian",
            "Bosna i Hercegovina",
            "Federation of Bosnia and Herzegovina"
        ]
    },
    {
        "label": "Botswana",
        "value": "BW",
        "logo": "🇧🇼",
        "searchTerms": [
            "Botswanan",
            "Republic of Botswana",
            "Botswana",
            "BW",
            "BWA",
            "Motswana"
        ]
    },
    {
        "label": "Brazil",
        "value": "BR",
        "logo": "🇧🇷",
        "searchTerms": [
            "Brasil",
            "Brazilian",
            "Brasilia",
            "Brazil",
            "BR",
            "BRA",
            "Federative Republic of Brazil",
            "Brasil país"
        ]
    },
    {
        "label": "Brunei Darussalam",
        "value": "BN",
        "logo": "🇧🇳",
        "searchTerms": [
            "Brunei",
            "Bruneian",
            "Negara Brunei Darussalam",
            "Brunei Darussalam",
            "BN",
            "BRN",
            "Sultanate of Brunei",
            "Brunei Sultanate"
        ]
    },
    {
        "label": "Bulgaria",
        "value": "BG",
        "logo": "🇧🇬",
        "searchTerms": [
            "Balgariya",
            "Bulgaria",
            "BG",
            "BGR",
            "Republic of Bulgaria",
            "Bulgarie",
            "Bolgariya"
        ]
    },
    {
        "label": "Burkina Faso",
        "value": "BF",
        "logo": "🇧🇫",
        "searchTerms": [
            "Burkinabe",
            "Burkina",
            "Burkina Faso",
            "BF",
            "BFA",
            "Republic of Burkina Faso",
            "Faso"
        ]
    },
    {
        "label": "Burundi",
        "value": "BI",
        "logo": "🇧🇮",
        "searchTerms": [
            "Republic of Burundi",
            "Burundi",
            "BI",
            "BDI",
            "Burundians"
        ]
    },
    {
        "label": "Cabo Verde",
        "value": "CV",
        "logo": "🇨🇻",
        "searchTerms": [
            "Cape Verde",
            "Cabo Verdean",
            "Republic of Cabo Verde",
            "Cabo Verde",
            "CV",
            "CPV",
            "Cape Verde Islands",
            "Cabo Verde Islands"
        ]
    },
    {
        "label": "Cambodia",
        "value": "KH",
        "logo": "🇰🇭",
        "searchTerms": [
            "Khmer",
            "Kampuchea",
            "KH",
            "KHM",
            "Kingdom of Cambodia",
            "Khmer Country"
        ]
    },
    {
        "label": "Cameroon",
        "value": "CM",
        "logo": "🇨🇲",
        "searchTerms": [
            "Cameroonian",
            "Republic of Cameroon",
            "Cameroon",
            "CM",
            "CMR",
            "Cameroun",
            "Kamerun"
        ]
    },
    {
        "label": "Canada",
        "value": "CA",
        "logo": "🇨🇦",
        "searchTerms": [
            "CAN",
            "Canada",
            "CA",
            "CANADA",
            "CDN",
            "Great White North"
        ]
    },
    {
        "label": "Cayman Islands",
        "value": "KY",
        "logo": "🇰🇾",
        "searchTerms": [
            "Cayman",
            "Caymans",
            "Cayman Isles",
            "KY",
            "CYM",
            "Grand Cayman",
            "Caymanian"
        ]
    },
    {
        "label": "Central African Republic",
        "value": "CF",
        "logo": "🇨🇫",
        "searchTerms": [
            "CAR",
            "Centrafrique",
            "Central Africa",
            "République centrafricaine",
            "CF",
            "CAF",
            "Central African"
        ]
    },
    {
        "label": "Chad",
        "value": "TD",
        "logo": "🇹🇩",
        "searchTerms": [
            "Tchad",
            "Republic of Chad",
            "Chadian",
            "TD",
            "TCD",
            "Tchadian"
        ]
    },
    {
        "label": "Chile",
        "value": "CL",
        "logo": "🇨🇱",
        "searchTerms": [
            "Chile",
            "CL",
            "CHL",
            "Republic of Chile",
            "Chile Country"
        ]
    },
    {
        "label": "China",
        "value": "CN",
        "logo": "🇨🇳",
        "searchTerms": [
            "China",
            "PRC",
            "People's Republic of China",
            "Zhongguo",
            "CN",
            "CHN"
        ]
    },
    {
        "label": "Colombia",
        "value": "CO",
        "logo": "🇨🇴",
        "searchTerms": [
            "Colombia",
            "Colombian",
            "Republic of Colombia",
            "CO",
            "COL"
        ]
    },
    {
        "label": "Comoros",
        "value": "KM",
        "logo": "🇰🇲",
        "searchTerms": [
            "Comoros",
            "Union of the Comoros",
            "KM",
            "COM",
            "Comoro Islands"
        ]
    },
    {
        "label": "Congo",
        "value": "CG",
        "logo": "🇨🇬",
        "searchTerms": [
            "Republic of the Congo",
            "Congo-Brazzaville",
            "Brazzaville",
            "Congo"
        ]
    },
    {
        "label": "Congo, Democratic Republic",
        "value": "CD",
        "logo": "🇨🇩",
        "searchTerms": [
            "Democratic Republic of the Congo",
            "DR Congo",
            "DRC",
            "Congo-Kinshasa",
            "Kinshasa",
            "Congolese",
            "Zaire"
        ]
    },
    {
        "label": "Costa Rica",
        "value": "CR",
        "logo": "🇨🇷",
        "searchTerms": ["C.Rica", "CostaRica"]
    },
    {
        "label": "Croatia",
        "value": "HR",
        "logo": "🇭🇷",
        "searchTerms": ["Hrvatska", "Croasia"]
    },
    {
        "label": "Cuba",
        "value": "CU",
        "logo": "🇨🇺",
        "searchTerms": ["Republic of Cuba", "Cuba Island"]
    },
    {
        "label": "Cyprus",
        "value": "CY",
        "logo": "🇨🇾",
        "searchTerms": ["Kypros", "Kıbrıs", "Republic of Cyprus"]
    },
    {
        "label": "Czechia",
        "value": "CZ",
        "logo": "🇨🇿",
        "searchTerms": ["Czech Republic", "Czech", "Česko"]
    },
    {
        "label": "Denmark",
        "value": "DK",
        "logo": "🇩🇰",
        "searchTerms": ["Danmark", "Kingdom of Denmark"]
    },
    {
        "label": "Djibouti",
        "value": "DJ",
        "logo": "🇩🇯",
        "searchTerms": ["Jibuti", "Gibuti", "Republic of Djibouti"]
    },
    {
        "label": "Dominica",
        "value": "DM",
        "logo": "🇩🇲",
        "searchTerms": ["Commonwealth of Dominica"]
    },
    {
        "label": "Dominican Republic",
        "value": "DO",
        "logo": "🇩🇴",
        "searchTerms": ["República Dominicana", "Dominican"]
    },
    {
        "label": "Ecuador",
        "value": "EC",
        "logo": "🇪🇨",
        "searchTerms": ["Ecuadorean", "Ecuadorian", "República del Ecuador"]
    },
    {
        "label": "Egypt",
        "value": "EG",
        "logo": "🇪🇬",
        "searchTerms": ["Arab Republic of Egypt", "Misr", "Egyptian"]
    },
    {
        "label": "El Salvador",
        "value": "SV",
        "logo": "🇸🇻",
        "searchTerms": ["Salvador", "Salvadoran", "Republic of El Salvador"]
    },
    {
        "label": "Equatorial Guinea",
        "value": "GQ",
        "logo": "🇬🇶",
        "searchTerms": ["Guinea Equatorial", "Equatoguinean", "República de Guinea Ecuatorial"]
    },
    {
        "label": "Eswatini",
        "value": "SZ",
        "logo": "🇸🇿",
        "searchTerms": ["Swaziland", "Swazi", "Kingdom of Eswatini"]
    },
    {
        "label": "Eritrea",
        "value": "ER",
        "logo": "🇪🇷",
        "searchTerms": ["Eritrean", "State of Eritrea", "Ertra"]
    },
    {
        "label": "Estonia",
        "value": "EE",
        "logo": "🇪🇪",
        "searchTerms": ["Eesti", "Estonian", "Republic of Estonia"]
    },
    {
        "label": "Ethiopia",
        "value": "ET",
        "logo": "🇪🇹",
        "searchTerms": ["Abyssinia", "Ethiopian", "Federal Democratic Republic of Ethiopia"]
    },
    {
        "label": "Falkland Islands",
        "value": "FK",
        "logo": "🇫🇰",
        "searchTerms": ["Islas Malvinas", "Malvinas", "Falklands"]
    },
    {
        "label": "Fiji",
        "value": "FJ",
        "logo": "🇫🇯",
        "searchTerms": ["Fijian", "Republic of Fiji", "Viti"]
    },
    {
        "label": "Finland",
        "value": "FI",
        "logo": "🇫🇮",
        "searchTerms": ["Suomi", "Finnish", "Republic of Finland"]
    },
    {
        "label": "France",
        "value": "FR",
        "logo": "🇫🇷",
        "searchTerms": ["French", "République française", "Francia"]
    },
    {
        "label": "French Polynesia",
        "value": "PF",
        "logo": "🇵🇫",
        "searchTerms": ["Tahiti", "Polynésie française", "Overseas France"]
    },
    {
        "label": "Gabon",
        "value": "GA",
        "logo": "🇬🇦",
        "searchTerms": ["Gabonese", "Gabon Republic", "Gabon Afrique"]
    },
    {
        "label": "Gambia",
        "value": "GM",
        "logo": "🇬🇲",
        "searchTerms": ["The Gambia", "Gambian", "Republic of The Gambia"]
    },
    {
        "label": "Georgia",
        "value": "GE",
        "logo": "🇬🇪",
        "searchTerms": ["Sakartvelo", "Republic of Georgia", "Gurjistan", "Vrastan"]
    },
    {
        "label": "Germany",
        "value": "DE",
        "logo": "🇩🇪",
        "searchTerms": ["Deutschland", "German", "Federal Republic of Germany"]
    },
    {
        "label": "Ghana",
        "value": "GH",
        "logo": "🇬🇭",
        "searchTerms": ["Ghanaian","Gold Coast", "Republic of Ghana"]
    },
    {
        "label": "Greece",
        "value": "GR",
        "logo": "🇬🇷",
        "searchTerms": ["Hellas", "Hellenic Republic", "Hellada"]
    },
    {
        "label": "Greenland",
        "value": "GL",
        "logo": "🇬🇱",
        "searchTerms": ["Kalaallit Nunaat", "Greenlandic", "Kalaallit"]
    },
    {
        "label": "Grenada",
        "value": "GD",
        "logo": "🇬🇩",
        "searchTerms": ["Grenadian", "Caribbean Grenada"]
    },
    {
        "label": "Guam",
        "value": "GU",
        "logo": "🇬🇺",
        "searchTerms": ["Chamorro", "US Territory Guam"]
    },
    {
        "label": "Guatemala",
        "value": "GT",
        "logo": "🇬🇹",
        "searchTerms": ["Guatemalan", "Guate"]
    },
    {
        "label": "Guernsey",
        "value": "GG",
        "logo": "🇬🇬",
        "searchTerms": ["Bailiwick of Guernsey", "Guernsey Island"]
    },
    {
        "label": "Guinea",
        "value": "GN",
        "logo": "🇬🇳",
        "searchTerms": ["Guinean", "Republic of Guinea", "Guinée", "West Africa Guinea"]
    },
    {
        "label": "Guinea-Bissau",
        "value": "GW",
        "logo": "🇬🇼",
        "searchTerms": ["Bissau", "Guinean Bissau", "Republic of Guinea-Bissau", "Guiné-Bissau"]
    },
    {
        "label": "Guyana",
        "value": "GY",
        "logo": "🇬🇾",
        "searchTerms": ["Guyanese", "Co-operative Republic of Guyana"]
    },
    {
        "label": "Haiti",
        "value": "HT",
        "logo": "🇭🇹",
        "searchTerms": ["Haitian", "Republic of Haiti", "Ayiti"]
    },
    {
        "label": "Honduras",
        "value": "HN",
        "logo": "🇭🇳",
        "searchTerms": ["Honduran", "Republic of Honduras"]
    },
    {
        "label": "Hungary",
        "value": "HU",
        "logo": "🇭🇺",
        "searchTerms": ["Hungarian", "Magyar", "Magyarország", "Republic of Hungary"]
    },
    {
        "label": "Iceland",
        "value": "IS",
        "logo": "🇮🇸",
        "searchTerms": ["Icelandic", "Island"]
    },
    {
        "label": "India",
        "value": "IN",
        "logo": "🇮🇳",
        "searchTerms": ["Bharat", "Hindustan"]
    },
    {
        "label": "Indonesia",
        "value": "ID",
        "logo": "🇮🇩",
        "searchTerms": ["Republik Indonesia", "Nusantara"]
    },
    {
        "label": "Iran",
        "value": "IR",
        "logo": "🇮🇷",
        "searchTerms": [
            "Iranian",
            "Persia",
            "Islamic Republic of Iran"
        ]
    },
    {
        "label": "Iraq",
        "value": "IQ",
        "logo": "🇮🇶",
        "searchTerms": [
            "Iraqi",
            "Mesopotamia"
        ]
    },
    {
        "label": "Ireland",
        "value": "IE",
        "logo": "🇮🇪",
        "searchTerms": [
            "Irish",
            "Republic of Ireland",
            "Ireland Republic"
        ]
    },
    {
        "label": "Isle of Man",
        "value": "IM",
        "logo": "🇮🇲",
        "searchTerms": [
            "Manx", 
            "IsleofMan", 
            "Mann", 
            "Crown Dependency Isle of Man"
        ]
    },
    {
        "label": "Israel",
        "value": "IL",
        "logo": "🇮🇱",
        "searchTerms": [
            "Israeli", 
            "State of Israel", 
            "ISR"
        ]
    },
    {
        "label": "Italy",
        "value": "IT",
        "logo": "🇮🇹",
        "searchTerms": [
            "Italia", 
            "Italian Republic"
        ]
    },
    {
        "label": "Jamaica",
        "value": "JM",
        "logo": "🇯🇲",
        "searchTerms": ["Xaymaca", "Jamrock","Jamdown", "Island of Jamaica"]
    },
    {
        "label": "Japan",
        "value": "JP",
        "logo": "🇯🇵",
        "searchTerms": ["Nippon", "Nihon","JPN", "Land of the Rising Sun"]
    },
    {
        "label": "Jersey",
        "value": "JE",
        "logo": "🇯🇪",
        "searchTerms": ["Jersey Island", "Bailiwick of Jersey"]
    },
    {
        "label": "Jordan",
        "value": "JO",
        "logo": "🇯🇴",
        "searchTerms": ["Jordanian", "Hashemite Kingdom of Jordan", "JOR"]
    },
    {
        "label": "Kazakhstan",
        "value": "KZ",
        "logo": "🇰🇿",
        "searchTerms": ["Kazakh", "Republic of Kazakhstan", "KAZ", "Qazaqstan"]
    },
    {
        "label": "Kenya",
        "value": "KE",
        "logo": "🇰🇪",
        "searchTerms": ["Kenyan", "Republic of Kenya"]
    },
    {
        "label": "Kiribati",
        "value": "KI",
        "logo": "🇰🇮",
        "searchTerms": ["I-Kiribati", "Republic of Kiribati", "KIR"]
    },
    {
        "label": "Korea, North",
        "value": "KP",
        "logo": "🇰🇵",
        "searchTerms": ["North Korea", "DPRK", "Democratic People's Republic of Korea", "PRK"]
    },
    {
        "label": "Korea, South",
        "value": "KR",
        "logo": "🇰🇷",
        "searchTerms": ["South Korea", "ROK", "Republic of Korea", "KOR"]
    },
    {
        "label": "Kosovo",
        "value": "XK",
        "logo": "🇽🇰",
        "searchTerms": ["Kosovar", "Republic of Kosovo", "Kosova"]
    },
    {
        "label": "Kuwait",
        "value": "KW",
        "logo": "🇰🇼",
        "searchTerms": ["Kuwaiti", "State of Kuwait", "KWT"]
    },
    {
        "label": "Kyrgyzstan",
        "value": "KG",
        "logo": "🇰🇬",
        "searchTerms": ["Kyrgyz", "Kyrgyz Republic", "KGZ"]
    },
    {
        "label": "Laos",
        "value": "LA",
        "logo": "🇱🇦",
        "searchTerms": ["Lao", "Lao People's Democratic Republic", "Lao PDR"]
    },
    {
        "label": "Latvia",
        "value": "LV",
        "logo": "🇱🇻",
        "searchTerms": ["Republic of Latvia", "LAT"]
    },
    {
        "label": "Lebanon",
        "value": "LB",
        "logo": "🇱🇧",
        "searchTerms": ["Lebanese", "Lebanese Republic", "LBN"]
    },
    {
        "label": "Lesotho",
        "value": "LS",
        "logo": "🇱🇸",
        "searchTerms": ["Basotho", "Kingdom of Lesotho"]
    },
    {
        "label": "Liberia",
        "value": "LR",
        "logo": "🇱🇷",
        "searchTerms": ["Liberian", "Republic of Liberia", "LBR"]
    },
    {
        "label": "Libya",
        "value": "LY",
        "logo": "🇱🇾",
        "searchTerms": ["Libyan", "State of Libya", "LBY", "Libyan Arab Jamahiriya"]
    },
    {
        "label": "Liechtenstein",
        "value": "LI",
        "logo": "🇱🇮",
        "searchTerms": ["Principality of Liechtenstein"]
    },
    {
        "label": "Lithuania",
        "value": "LT",
        "logo": "🇱🇹",
        "searchTerms": ["Lietuva", "Republic of Lithuania"]
    },
    {
        "label": "Luxembourg",
        "value": "LU",
        "logo": "🇱🇺",
        "searchTerms": ["Luxembourger", "Luxemburg", "Grand Duchy of Luxembourg", "LUX"]
    },
    {
        "label": "Madagascar",
        "value": "MG",
        "logo": "🇲🇬",
        "searchTerms": ["Malagasy", "Republic of Madagascar", "Madagasikara"]
    },
    {
        "label": "Malawi",
        "value": "MW",
        "logo": "🇲🇼",
        "searchTerms": ["Malawian", "Republic of Malawi", "MWI"]
    },
    {
        "label": "Malaysia",
        "value": "MY",
        "logo": "🇲🇾",
        "searchTerms": ["Malaysian", "Malaysia Federation", "MYS", "Negara Malaysia"]
    },
    {
        "label": "Maldives",
        "value": "MV",
        "logo": "🇲🇻",
        "searchTerms": ["Republic of Maldives", "Maldive Islands"]
    },
    {
        "label": "Mali",
        "value": "ML",
        "logo": "🇲🇱",
        "searchTerms": ["Malian", "Republic of Mali", "Afrique de l'Ouest Mali"]
    },
    {
        "label": "Malta",
        "value": "MT",
        "logo": "🇲🇹",
        "searchTerms": ["Republic of Malta", "Republica ta' Malta"]
    },
    {
        "label": "Marshall Islands",
        "value": "MH",
        "logo": "🇲🇭",
        "searchTerms": ["Marshallese", "Republic of the Marshall Islands"]
    },
    {
        "label": "Mauritania",
        "value": "MR",
        "logo": "🇲🇷",
        "searchTerms": ["Mauritanian", "Islamic Republic of Mauritania"]
    },
    {
        "label": "Mauritius",
        "value": "MU",
        "logo": "🇲🇺",
        "searchTerms": ["Mauritian", "Republic of Mauritius", "Île Maurice"]
    },
    {
        "label": "Mexico",
        "value": "MX",
        "logo": "🇲🇽",
        "searchTerms": ["Estados Unidos Mexicanos", "MEX"]
    },
    {
        "label": "Micronesia",
        "value": "FM",
        "logo": "🇫🇲",
        "searchTerms": ["Federated States of Micronesia", "Micronesian"]
    },
    {
        "label": "Moldova",
        "value": "MD",
        "logo": "🇲🇩",
        "searchTerms": ["Moldovan", "Republic of Moldova"]
    },
    {
        "label": "Monaco",
        "value": "MC",
        "logo": "🇲🇨",
        "searchTerms": ["Monégasque", "Principality of Monaco"]
    },
    {
        "label": "Mongolia",
        "value": "MN",
        "logo": "🇲🇳",
        "searchTerms": ["Ulaanbaatar", "Mongol Uls"]
    },
    {
        "label": "Montenegro",
        "value": "ME",
        "logo": "🇲🇪",
        "searchTerms": ["Crna Gora", "Republic of Montenegro"]
    },
    {
        "label": "Montserrat",
        "value": "MS",
        "logo": "🇲🇸",
        "searchTerms": ["Montserratian", "Caribbean Montserrat"]
    },
    {
        "label": "Morocco",
        "value": "MA",
        "logo": "🇲🇦",
        "searchTerms": ["Kingdom of Morocco"]
    },
    {
        "label": "Mozambique",
        "value": "MZ",
        "logo": "🇲🇿",
        "searchTerms": ["Mozambican", "Republic of Mozambique", "MOZ", "Moçambique"]
    },
    {
        "label": "Myanmar",
        "value": "MM",
        "logo": "🇲🇲",
        "searchTerms": ["Burma", "Union of Myanmar"]
    },
    {
        "label": "Namibia",
        "value": "NA",
        "logo": "🇳🇦",
        "searchTerms": ["Republic of Namibia"]
    },
    {
        "label": "Nauru",
        "value": "NR",
        "logo": "🇳🇷",
        "searchTerms": ["Republic of Nauru"]
    },
    {
        "label": "Nepal",
        "value": "NP",
        "logo": "🇳🇵",
        "searchTerms": ["Federal Democratic Republic of Nepal", "NEP"]
    },
    {
        "label": "Netherlands",
        "value": "NL",
        "logo": "🇳🇱",
        "searchTerms": ["Holland", "Dutch", "Kingdom of the Netherlands", "Nederland"]
    },
    {
        "label": "New Caledonia",
        "value": "NC",
        "logo": "🇳🇨",
        "searchTerms": ["Territory of New Caledonia", "Nouvelle-Calédonie"]
    },
    {
        "label": "New Zealand",
        "value": "NZ",
        "logo": "🇳🇿",
        "searchTerms": ["Aotearoa", "NZL", "NewZealand"]
    },
    {
        "label": "Nicaragua",
        "value": "NI",
        "logo": "🇳🇮",
        "searchTerms": ["Nicaraguan", "Republic of Nicaragua", "NIC"]
    },
    {
        "label": "Niger",
        "value": "NE",
        "logo": "🇳🇪",
        "searchTerms": ["Nigerien", "Republic of Niger"]
    },
    {
        "label": "Nigeria",
        "value": "NG",
        "logo": "🇳🇬",
        "searchTerms": ["Federal Republic of Nigeria", "NGA"]
    },
    {
        "label": "Niue",
        "value": "NU",
        "logo": "🇳🇺",
        "searchTerms": ["Niuean"]
    },
    {
        "label": "North Macedonia",
        "value": "MK",
        "logo": "🇲🇰",
        "searchTerms": ["Macedonian", "Republic of North Macedonia", "Former Yugoslav Republic of Macedonia"]
    },
    {
        "label": "Norway",
        "value": "NO",
        "logo": "🇳🇴",
        "searchTerms": ["Kingdom of Norway", "Norge"]
    },
    {
        "label": "Oman",
        "value": "OM",
        "logo": "🇴🇲",
        "searchTerms": ["Omani", "Sultanate of Oman"]
    },
    {
        "label": "Pakistan",
        "value": "PK",
        "logo": "🇵🇰",
        "searchTerms": ["Islamic Republic of Pakistan", "PAK"]
    },
    {
        "label": "Palestine",
        "value": "PS",
        "logo": "🇵🇸",
        "searchTerms": [
            "Palestine, State of",
            "Palestine",
            "Palestinian",
            "State of Palestine",
            "PSE"
        ]
    },
    {
        "label": "Palau",
        "value": "PW",
        "logo": "🇵🇼",
        "searchTerms": ["Republic of Palau"]
    },
    {
        "label": "Panama",
        "value": "PA",
        "logo": "🇵🇦",
        "searchTerms": ["Republic of Panama"]
    },
    {
        "label": "Papua New Guinea",
        "value": "PG",
        "logo": "🇵🇬",
        "searchTerms": ["Independent State of Papua New Guinea"]
    },
    {
        "label": "Paraguay",
        "value": "PY",
        "logo": "🇵🇾",
        "searchTerms": ["Republic of Paraguay"]
    },
    {
        "label": "Peru",
        "value": "PE",
        "logo": "🇵🇪",
        "searchTerms": ["Perú"]
    },
    {
        "label": "Philippines",
        "value": "PH",
        "logo": "🇵🇭",
        "searchTerms": ["Filipino", "Pilipinas"]
    },
    {
        "label": "Poland",
        "value": "PL",
        "logo": "🇵🇱",
        "searchTerms": ["Polska"]
    },
    {
        "label": "Portugal",
        "value": "PT",
        "logo": "🇵🇹",
        "searchTerms": ["Portuguese Republic", "Portuguesa"]
    },
    {
        "label": "Puerto Rico",
        "value": "PR",
        "logo": "🇵🇷",
        "searchTerms": ["Commonwealth of Puerto Rico", "Caribbean PR"]
    },
    {
        "label": "Qatar",
        "value": "QA",
        "logo": "🇶🇦",
        "searchTerms": ["State of Qatar", "QAT"]
    },
    {
        "label": "Romania",
        "value": "RO",
        "logo": "🇷🇴",
        "searchTerms": ["România", "Romanian Republic"]
    },
    {
        "label": "Russia",
        "value": "RU",
        "logo": "🇷🇺",
        "searchTerms": ["Russian Federation",]
    },
    {
        "label": "Rwanda",
        "value": "RW",
        "logo": "🇷🇼",
        "searchTerms": ["RWA"]
    },
    {
        "label": "Saint Helena",
        "value": "SH",
        "logo": "🇱🇸",
        "searchTerms": ["Ascension and Tristan da Cunha", "Saint Helena, Ascension and Tristan da Cunha"]
    },
    {
        "label": "Saint Kitts and Nevis",
        "value": "KN",
        "logo": "🇰🇳",
        "searchTerms": ["Saint Kitts", "Nevis", "Kittitian", "Nevisian", "Federation of Saint Kitts and Nevis"]
    },
    {
        "label": "Saint Lucia",
        "value": "LC",
        "logo": "🇱🇨",
        "searchTerms": ["Saint Lucian", "Island of Saint Lucia"]
    },
    {
        "label": "Saint Martin",
        "value": "MF",
        "logo": "🇲🇫",
        "searchTerms": ["Sint Maarten (Dutch part)"]
    },
    {
        "label": "Saint Vincent and the Grenadines",
        "value": "VC",
        "logo": "🇻🇨",
        "searchTerms": ["Saint Vincent"]
    },
    {
        "label": "Samoa",
        "value": "WS",
        "logo": "🇼🇸",
        "searchTerms": ["Independent State of Samoa"]
    },
    {
        "label": "San Marino",
        "value": "SM",
        "logo": "🇸🇲",
        "searchTerms": ["Sammarinese"]
    },
    {
        "label": "Sao Tome and Principe",
        "value": "ST",
        "logo": "🇸🇹",
        "searchTerms": ["São Tomé", "Principe", "Sao Tomean", "Democratic Republic of São Tomé and Príncipe"]
    },
    {
        "label": "Saudi Arabia",
        "value": "SA",
        "logo": "🇸🇦",
        "searchTerms": [ "Saudi", "Kingdom of Saudi Arabia"]
    },
    {
        "label": "Senegal",
        "value": "SN",
        "logo": "🇸🇳",
        "searchTerms": ["Senegalese"]
    },
    {
        "label": "Serbia",
        "value": "RS",
        "logo": "🇷🇸",
        "searchTerms": ["Republic of Serbia", "Srbija"]
    },
    {
        "label": "Seychelles",
        "value": "SC",
        "logo": "🇸🇨",
        "searchTerms": ["Seychellois"]
    },
    {
        "label": "Sierra Leone",
        "value": "SL",
        "logo": "🇸🇱",
        "searchTerms": ["Sierra Leonean"]
    },
    {
        "label": "Singapore",
        "value": "SG",
        "logo": "🇸🇬",
        "searchTerms": ["Singaporean", "Lion City"]
    },
    {
        "label": "Slovakia",
        "value": "SK",
        "logo": "🇸🇰",
        "searchTerms": ["Slovak", "Slovak Republic", "Slovensko"]
    },
    {
        "label": "Slovenia",
        "value": "SI",
        "logo": "🇸🇮",
        "searchTerms": ["Slovene", "Slovenian", "Republika Slovenija"]
    },
    {
        "label": "Solomon Islands",
        "value": "SB",
        "logo": "🇸🇧",
        "searchTerms": ["Solomon Islander", "Solomon"]
    },
    {
        "label": "Somalia",
        "value": "SO",
        "logo": "🇸🇴",
        "searchTerms": ["Somali"]
    },
    {
        "label": "South Africa",
        "value": "ZA",
        "logo": "🇿🇦",
        "searchTerms": ["Africa"]
    },
    {
        "label": "South Sudan",
        "value": "SS",
        "logo": "🇸🇸",
        "searchTerms": ["South Sudanese", "Republic of South Sudan"]
    },
    {
        "label": "Spain",
        "value": "ES",
        "logo": "🇪🇸",
        "searchTerms": ["España", "Espana", "Kingdom of Spain"]
    },
    {
        "label": "Sri Lanka",
        "value": "LK",
        "logo": "🇱🇰",
        "searchTerms": ["Ceylon"]
    },
    {
        "label": "Sudan",
        "value": "SD",
        "logo": "🇸🇩",
        "searchTerms": ["Republic of the Sudan"]
    },
    {
        "label": "Suriname",
        "value": "SR",
        "logo": "🇸🇷",
        "searchTerms": ["Republic of Suriname"]
    },
    {
        "label": "Sweden",
        "value": "SE",
        "logo": "🇸🇪",
        "searchTerms": ["Kingdom of Sweden", "Sverige"]
    },
    {
        "label": "Switzerland",
        "value": "CH",
        "logo": "🇨🇭",
        "searchTerms": ["Swiss", "Schweiz", "Suisse", "Svizzera", "Swiss Confederation"]
    },
    {
        "label": "Syria",
        "value": "SY",
        "logo": "🇸🇾",
        "searchTerms": ["Syrian Arab Republic"]
    },
    {
        "label": "Taiwan",
        "value": "TW",
        "logo": "🇹🇼",
        "searchTerms": ["Formosa"]
    },
    {
        "label": "Tajikistan",
        "value": "TJ",
        "logo": "🇹🇯",
        "searchTerms": ["Tajik"]
    },
    {
        "label": "Tanzania",
        "value": "TZ",
        "logo": "🇹🇿",
        "searchTerms": ["United Republic of Tanzania"]
    },
    {
        "label": "Thailand",
        "value": "TH",
        "logo": "🇹🇭",
        "searchTerms": ["Kingdom of Thailand", "Siam"]
    },
    {
        "label": "Timor-Leste",
        "value": "TL",
        "logo": "🇹🇱",
        "searchTerms": ["East Timor", "Timorese", "Democratic Republic of Timor-Leste"]
    },
    {
        "label": "Togo",
        "value": "TG",
        "logo": "🇹🇬",
        "searchTerms": ["Togolese", "Togolese Republic"]
    },
    {
        "label": "Tonga",
        "value": "TO",
        "logo": "🇹🇴",
        "searchTerms": ["Tongan", "Kingdom of Tonga"]
    },
    {
        "label": "Trinidad and Tobago",
        "value": "TT",
        "logo": "🇹🇹",
        "searchTerms": ["Trinidad", "Tobago"]
    },
    {
        "label": "Tunisia",
        "value": "TN",
        "logo": "🇹🇳",
        "searchTerms": ["Tunis", "Tunisian Republic"]
    },
    {
        "label": "Turkey",
        "value": "TR",
        "logo": "🇹🇷",
        "searchTerms": ["Türkiye"]
    },
    {
        "label": "Turkmenistan",
        "value": "TM",
        "logo": "🇹🇲",
        "searchTerms": ["Turkmen", "Türkmenistan"]
    },
    {
        "label": "Tuvalu",
        "value": "TV",
        "logo": "🇹🇻",
        "searchTerms": ["Tuvaluan", "Ellice Islands"]
    },
    {
        "label": "Uganda",
        "value": "UG",
        "logo": "🇺🇬",
        "searchTerms": ["Ugandan"]
    },
    {
        "label": "Ukraine",
        "value": "UA",
        "logo": "🇺🇦",
        "searchTerms": ["Ukrayina"]
    },
    {
        "label": "UAE",
        "value": "AE",
        "logo": "🇦🇪",
        "searchTerms": ["United Arab Emirates", "UAE", "Emirates"]
    },
    {
        "label": "United Kingdom",
        "value": "GB",
        "logo": "🇬🇧",
        "searchTerms": ["UK", "Great Britain", "Britain", "England", "Scotland", "Wales", "Northern Ireland", "GB", "GBR", "British Isles"]
    },
    {
        "label": "USA",
        "value": "US",
        "logo": "🇺🇸",
        "searchTerms": ["United States", "United States of America", "USA", "America"]
    },
    {
        "label": "Uruguay",
        "value": "UY",
        "logo": "🇺🇾",
        "searchTerms": ["Uruguayan", "Eastern Republic of Uruguay"]
    },
    {
        "label": "Uzbekistan",
        "value": "UZ",
        "logo": "🇺🇿",
        "searchTerms": ["Uzbek"]
    },
    {
        "label": "Vanuatu",
        "value": "VU",
        "logo": "🇻🇺",
        "searchTerms": ["Ni-Vanuatu"]
    },
    {
        "label": "Venezuela",
        "value": "VE",
        "logo": "🇻🇪",
        "searchTerms": ["Bolivarian Republic of Venezuela"]
    },
    {
        "label": "Vietnam",
        "value": "VN",
        "logo": "🇻🇳",
        "searchTerms": ["Việt Nam"]
    },
    {
        "label": "Yemen",
        "value": "YE",
        "logo": "🇾🇪",
        "searchTerms": ["Yemeni"]
    },
    {
        "label": "Zambia",
        "value": "ZM",
        "logo": "🇿🇲",
        "searchTerms": ["ZMB"]
    },
    {
        "label": "Zimbabwe",
        "value": "ZW",
        "logo": "🇿🇼",
        "searchTerms": ["Zimbabwean"]
    }
]


export const residentIDCardName = {
    "AE": "Emirates ID",
    "IN": "Aadhaar Card",
    "ES": "National Identity Document (DNI)",
    "DE": "Personal ID Card",
    "FR": "Carte Nationale d’Identité (CNI)",
    "IT": "Identity Card",
    "BR": "General Registry (RG)",
    "AR": "National Identity Document (DNI)",
    "JP": "My Number Card",
    "KR": "Resident Registration Card",
    "CN": "Resident Identity Card",
    "MY": "MyKad",
    "SG": "National Registration Identity Card (NRIC)",
    "HK": "Hong Kong Identity Card (HKID)",
    "NL": "National ID Card",
    "SA": "Residency Permit (Iqama)",
    "ZA": "Identity Card",
    "PH": "PhilSys ID",
    "PK": "Computerized National Identity Card (CNIC)",
    "RU": "Internal Passport",
    "TH": "National ID Card",
    "ID": "Resident Identity Card (KTP)",
    "TR": "Identity Card",
    "VN": "Citizen Identification Card",
    "BD": "National Identity Card (NID)",
    "EG": "National ID Card",
    "CO": "Citizenship Card",
    "CL": "National Identity Card",
    "PE": "National Identity Document (DNI)",
    "VE": "Identity Card",
    "NG": "National Identity Number (NIN)",
    "KE": "National ID Card",
    "GH": "Ghana Card",
    "MA": "National Identity Card (CNIE)",
    "NO": "National ID Card",
    "PL": "Identity Card",
    "PT": "Citizen Card",
    "GR": "Police Identity Card",
    "FI": "Identity Card",
    "SE": "National ID Card",
    "PS": "ID Card"
};

export const drivingLicenceName = {
    "BR": "CNH (Carteira de Motorista)",
    "FR": "Permis de Conduire"
};

export const idCardName = {
    "BR": "RG/CIN - ID Card"
};
